<basic-alert></basic-alert>

<router-outlet></router-outlet>
@if (showFooter) {
  <app-footer class="mt-auto"></app-footer>
}



